var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormElement,{attrs:{"id":_setup.id,"value":_setup.label,"error":_setup.error,"title":_setup.title,"type":"text","help":"Provide a short, unique name to describe this output."},on:{"input":_setup.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }